import { useEffect, useState } from 'react'
import { getLanguages } from '../../api/curriculum/curriculum'
import { openNotificationWithIcon } from '../../utils/helper'

const useLanguages = () => {
	const [languages, setLanguages] = useState([])
	const [loadingLanguages, setLoadingLanguages] = useState(false)


	const fetchLanguages = async () => {
		try {
			setLoadingLanguages(true)
			const res = await getLanguages()
			const { data } = res.data
			setLanguages(data)
			setLoadingLanguages(false)
		} catch (error: any) {
			setLoadingLanguages(false)
			if (error?.response) {
				openNotificationWithIcon('error', 'Get Languages', `${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'Get Languages', 'Something went wrong')
			}
		}
	}

	useEffect(() => {
		fetchLanguages()

		// eslint-disable-next-line
	}, [])

	return { languages, loadingLanguages }
}

export default useLanguages